import { ItemsPerPage } from '@billy/design-system'
import qs from 'qs'

import { getCurrentLocale, getRequest, patchRequest } from '../../../../utils'

interface FetchVatSuggestionsPayload {
  organizationId: string
  payload: {
    entryDatePeriod?: string
    isApproved?: boolean
    isReviewed?: boolean
    page?: number
    pageSize?: ItemsPerPage
  }
}

export const fetchVatSuggestions = ({ organizationId, payload }: FetchVatSuggestionsPayload) => {
  const locale = getCurrentLocale()
  /* Only supporting DK and EN translated suggestions for now */
  const preferredLocale = locale === 'da_DK' ? 'da_DK' : 'en_US'

  const { entryDatePeriod, isReviewed, isApproved, page, pageSize } = payload

  const queryParams = qs.stringify({
    organizationId,
    ...(entryDatePeriod ? { entryDatePeriod } : {}),
    ...(isApproved ? { isApproved } : { isApproved: 0 }),
    ...(isReviewed ? { isReviewed } : { isReviewed: 0 }),
    ...(page ? { page } : {}),
    ...(pageSize ? { pageSize } : {}),
  })

  return getRequest(`/v2/vatSuggestions?${queryParams}`, {
    'Accept-Language': preferredLocale,
  })
}

interface VatSuggestionChange {
  id: string
  isApproved: boolean
  isReviewed: boolean
  selectedTaxRateId?: string
}

interface ApplyVatSuggestionChangesPayload {
  organizationId: string
  payload: {
    vatSuggestions: VatSuggestionChange[]
  }
}

export const applyVatSuggestionChanges = ({ organizationId, payload }: ApplyVatSuggestionChangesPayload) => {
  return patchRequest(`/v2/vatSuggestions?organizationId=${organizationId}`, payload)
}
